import * as React from 'react';
import { useTranslation } from "react-i18next";
import { useHistory } from 'react-router-dom';
import { Form, Field, FormElement } from "@progress/kendo-react-form";
import { CustomInput, CustomCheckbox, CustomTextArea, CustomIntInput } from "../ButtonComponentsPanel/CustomInputsComponents";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { ProcessError, ErrorCode } from "../../classes/ExceptionProcessor";

import FarmsService from "../../services/farms.service";

export default function FarmDetailsComponents(props) {
    const { t } = useTranslation();
    const [loading, setLoading] = React.useState(true);
    const history = useHistory();

    // Error Hooks
    const [visibleError, setVisibleError] = React.useState(false);
    const [errorData, setErrorData] = React.useState({ messageError: "", code: "" });

    const [farm, setFarm] = React.useState({
        "farmId": 0,
        "integratorId": 0,
        "integratorCode": "",
        "manufacturerCode": "",
        "name": "",
        "officialMark": "",
        "regaCode": "",
        "gpsCordinates": "",
        "address": "",
        "city": "",
        "postcode": "",
        "provinceId": 0,
        "countryId": "",
        "remarks": "",
        "isInactive": false,
        "region": "",
        "distributionZoneId": 0,
        "farmTypeId": 0,
        "efficiencyRatio": 0
    });

    React.useEffect(() => {
        if (props.farm.farmId !== "") {
            setFarm({
                "farmId": props.farm.farmId,
                "integratorId": props.farm.integratorId,
                "integratorCode": props.farm.integratorCode,
                "manufacturerCode": props.farm.manufacturerCode,
                "name": props.farm.name,
                "officialMark": props.farm.officialMark,
                "regaCode": props.farm.regaCode,
                "gpsCordinates": props.farm.gpsCordinates,
                "address": props.farm.address,
                "city": props.farm.city,
                "postcode": props.farm.postcode,
                "provinceId": props.farm.provinceId,
                "countryId": props.farm.countryId,
                "remarks": props.farm.remarks,
                "isInactive": props.farm.isInactive,
                "region": props.farm.region,
                "distributionZoneId": props.farm.distributionZoneId,
                "farmTypeId": props.farm.farmTypeId,
                "efficiencyRatio": props.farm.efficiencyRatio

            });
            setLoading(false);
        }
    }, [props.farm]);

    const handleSubmit = (dataItem) => {
        FarmsService.updateFarm(farm.farmId, {
            "integratorId": dataItem.integratorId,
            "integratorCode": dataItem.integratorCode,
            "manufacturerCode": dataItem.manufacturerCode,
            "name": dataItem.name,
            "officialMark": dataItem.officialMark,
            "regaCode": dataItem.regaCode,
            "gpsCordinates": dataItem.gpsCordinates,
            "address": dataItem.address,
            "city": dataItem.city,
            "postcode": dataItem.postcode,
            "provinceId": dataItem.provinceId,
            "countryId": dataItem.countryId,
            "remarks": dataItem.remarks,
            "isInactive": dataItem.isInactive,
            "region": dataItem.region,
            "distributionZoneId": dataItem.distributionZoneId,
            "farmTypeId": dataItem.farmTypeId,
            "efficiencyRatio": dataItem.efficiencyRatio
        }).then(() => {
            history.push("/Farms/" + farm.farmId + "/DetailsFarms"); 
        }).catch((err) => {
            setVisibleError(true);
            setLoading(false);
            setErrorData({ messageError: ProcessError(err), code: ErrorCode(err) });
        });
    }



    return (
        <div>
            {visibleError && (
                <Dialog title={"Error " + errorData.code} onClose={() => { setVisibleError(false) }}>
                    <p style={{ margin: "25px", textAlign: "center" }}>
                        <b>{errorData.messageError}</b>
                    </p>
                    <DialogActionsBar>
                        <button className="k-button" onClick={() => { setVisibleError(false) }}>
                            OK
                        </button>
                    </DialogActionsBar>
                </Dialog>
            )}
            <Form
                onSubmit={handleSubmit}
                initialValues={farm}
                key={JSON.stringify(farm)}
                render={(formRenderProps) => (
                    <FormElement>
                        <fieldset>
                            <div className="container-fluid">
                                <div className="card">
                                    <div className="card-header">
                                        <b className="card-title">{t("Global_Label_Text_General")}</b>
                                    </div>

                                    <div className="container p-3 p-md-4">
                                        <div className="row g-3 mb-3 mb-md-4">
                                            <div className="col-12 col-sm-6 col-md-3">
                                                <Field
                                                    label={t("Global_Label_Text_Id")}
                                                    name={'farmId'}
                                                    component={CustomInput}
                                                    loading={loading}
                                                    disabled={true}
                                                />
                                            </div>
                                            <div className="col-12 col-sm-6 col-md-3">
                                                <Field
                                                    label={t("Global_Label_Text_Name")}
                                                    name={'name'}
                                                    component={CustomInput}
                                                    loading={loading}
                                                    disabled={false}
                                                />
                                            </div>

                                            <div className="col-12 col-sm-6 col-md-3">
                                                <Field
                                                    label={t("REGA")}
                                                    name={'regaCode'}
                                                    component={CustomInput}
                                                    loading={loading}
                                                    disabled={false}
                                                />
                                            </div>

                                            <div className="col-12 col-sm-6 col-md-3">
                                                <Field
                                                    label={t("Global_Label_Text_Inactive")}
                                                    name={'isInactive'}
                                                    component={CustomCheckbox}
                                                    loading={loading}
                                                    disabled={false}
                                                />
                                            </div>


                                        </div>

                                        <div className="row g-3">
                                            <div className="col-12 col-sm-6 col-md-3">
                                                <Field
                                                    label={t("Global_Label_Text_Integrator")}
                                                    name={'integratorId'}
                                                    component={CustomInput}
                                                    loading={loading}
                                                    disabled={false}
                                                />
                                            </div>
                                            <div className="col-12 col-sm-6 col-md-4">
                                                <Field
                                                    label={t("Global_Label_Text_Code_Integrator")}
                                                    name={'integratorCode'}
                                                    component={CustomInput}
                                                    loading={loading}
                                                    disabled={false}
                                                />
                                            </div>

                                            <div className="col-12 col-sm-6 col-md-4">
                                                <Field
                                                    label={t("Global_Label_Text_Manufacturer_Code")}
                                                    name={'manufacturerCode'}
                                                    component={CustomInput}
                                                    loading={loading}
                                                    disabled={false}
                                                />
                                            </div>

                                            <div className="col-12 col-sm-12 col-md-4">
                                                <div className="d-flex align-items-center h-100">
                                                    <Field
                                                        label={t("Global_Label_Text_Official_Brand")}
                                                        name={'officialMark'}
                                                        component={CustomInput}
                                                        loading={loading}
                                                        disabled={false}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="container-fluid mt-4">
                                <div className="card">
                                    <div className="card-header">
                                        <b className="card-title m-0">{t("Global_Label_Text_Location")}</b>
                                    </div>

                                    <div className="container p-3 p-md-4">
                                        <div className="row g-3 mb-3 mb-md-4">
                                            <div className="col-12 col-sm-6 col-md-3">
                                                <Field
                                                    label={t("Global_Label_Text_Address")}
                                                    name={'address'}
                                                    component={CustomInput}
                                                    loading={loading}
                                                    disabled={false}
                                                />
                                            </div>

                                            <div className="col-12 col-sm-6 col-md-3">
                                                <Field
                                                    label={t("Global_Label_Text_City")}
                                                    name={'city'}
                                                    component={CustomInput}
                                                    loading={loading}
                                                    disabled={false}
                                                />
                                            </div>

                                            <div className="col-12 col-sm-6 col-md-3">
                                                <Field
                                                    label={t("Global_Label_Text_Postcode")}
                                                    name={'postcode'}
                                                    component={CustomInput}
                                                    loading={loading}
                                                    disabled={false}
                                                />
                                            </div>

                                            <div className="col-12 col-sm-6 col-md-3">
                                                <Field
                                                    label={t("Global_Label_Text_GPS_Coordinates")}
                                                    name={'gpsCordinates'}
                                                    component={CustomInput}
                                                    loading={loading}
                                                    disabled={false}
                                                />
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>

                            <div className="container-fluid mt-4">
                                <div className="row g-4">
                                    <div className="col-12 col-md-6">
                                        <div className="card h-100">
                                            <div className="card-header">
                                                <b className="card-title m-0">{t("Global_Label_Text_Parameters")}</b>
                                            </div>

                                            <div className="container p-3 p-md-4">
                                                <div className="row justify-content-center">
                                                    <div className="col-12 text-center">
                                                        <Field
                                                            label={t("Global_Label_Text_Eficiency")}
                                                            name={'efficiencyRatio'}
                                                            component={CustomIntInput}
                                                            loading={loading}
                                                            disabled={false}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12 col-md-6">
                                        <div className="card h-100">
                                            <div className="card-header">
                                                <b className="card-title m-0">{t("Global_Label_Text_Remarks")}</b>
                                            </div>

                                            <div className="container p-3 p-md-4">
                                                <div className="row justify-content-center">
                                                    <div className="col-12 text-center">
                                                        <Field
                                                            label={t("Global_Label_Text_Remarks")}
                                                            name={'remarks'}
                                                            component={CustomTextArea}
                                                            loading={loading}
                                                            disabled={false}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </fieldset>

                        <div className="float-end k-form-buttons">
                            <button
                                type={'submit'}
                                disabled={!formRenderProps.allowSubmit}
                                className="k-button"
                            >
                                <span className="k-icon k-i-save" /> &nbsp; {t("Global_Label_Text_Save")}
                            </button>
                        </div>


                    </FormElement>)}
            />
        </div>
    );
}